import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import WheelSearch from '@/components/search/WheelSearch/WheelSearch'
import { getPageTitle } from '@/utils/helpers'
import PageInfo from '@/components/common/PageInfo/PageInfo'
import Raw from '@/components/common/Raw/Raw'
import { useTranslation } from 'next-i18next'
import ContentSV, { meta as metaSV } from '@/content/seo/sv/kompletta-hjul.mdx'
import ContentEN, { meta as metaEN } from '@/content/seo/en/wheels.mdx'
import { SeoContent } from '@/lib/seo/seoPage'
import { useSeoLocaleContent } from '@/lib/seo/seoRoute'
import { useSeoLocale } from '@/lib/seo/useSeoLocale'
import { useSeoLinks } from '@/lib/seo/seoLinks'

const byLocale = {
  sv: { meta: metaSV, Content: ContentSV },
  en: { meta: metaEN, Content: ContentEN },
}

type Props = {}

const WheelsPage = (props: Props) => {
  const { t } = useTranslation('common')
  const locale = useSeoLocale()
  const { meta, Content } = useSeoLocaleContent(byLocale)

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('wheels:title'), locale)}</title>
        <meta name="description" content={t('wheels:description') || ''} />
        {useSeoLinks(meta)}
      </Head>
      <main>
        <PageInfo>
          <h1>{t('wheels:header')}</h1>
          <Raw content={t('wheels:pageDescription')} />
        </PageInfo>
        <WheelSearch />

        <PageInfo>
          <SeoContent demoteHeadings>
            <Content />
          </SeoContent>
        </PageInfo>
      </main>
    </BaseLayout>
  )
}

export default WheelsPage

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'rims',
      'wheels',
      'shop',
      'footer',
    ])),
  },
})
